import Component from '../abstracts/Component';
// import RegisterLogic from '../logics/RegisterLogic';

export default class RegistrationStep1Component extends Component {

  get SELECTORS() {
    return {
      registrationProceedEmail: '#registerForm #email',
      registrationProceedBtn: '#registration-proceed-btn'
    };
  }


  get CLASSNAMES() {
    return {
      disabled: "disabled"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.registrationProceedEmail = this.$component.querySelector(this.SELECTORS.registrationProceedEmail);
    this.registrationProceedBtn = this.$component.querySelector(this.SELECTORS.registrationProceedBtn);
  }

  handleProceedBtnStatus(event) {
    if (event.target.value !== '') {
      this.registrationProceedBtn.removeAttribute(this.CLASSNAMES.disabled);
      this.registrationProceedBtn.classList.remove(this.CLASSNAMES.disabled);
    } else {
      this.registrationProceedBtn.setAttribute(this.CLASSNAMES.disabled);
      this.registrationProceedBtn.classList.add(this.CLASSNAMES.disabled);
    }
  }

  bindEvents() {
    this.registrationProceedEmail && this.registrationProceedEmail.addEventListener('input', (e) => this.handleProceedBtnStatus(e));
  }

  render() {
    this.bindEvents();
  }

}
